import { StringHelper } from "@/helpers/utilities/StringHelper";

export class JwtHelper {
  static decodeJwtToken(token) {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch {
      return null;
    }
  }

  static getCustomerId(token) {
    const tokenObj = this.decodeJwtToken(token);
    if (tokenObj) {
      return StringHelper.toGuid(tokenObj.RawCId);
    }
    return null;
  }

  static getInstitutionId(token) {
    const tokenObj = this.decodeJwtToken(token);
    if (tokenObj) {
      return StringHelper.toGuid(tokenObj.RawOId);
    }
    return null;
  }

  static getUserId(token) {
    const tokenObj = this.decodeJwtToken(token);
    if (tokenObj) {
      return StringHelper.toGuid(tokenObj.nameid);
    }
    return null;
  }

  static getRoles(token) {
    const tokenObj = this.decodeJwtToken(token);
    return tokenObj?.Roles ?? [];
  }
}
